import { StickerState } from '@/shared/models';
export function getStickerStateChipColor(stickerState) {
    switch (stickerState) {
        case StickerState.Receipted:
            return 'violet';
        case StickerState.Placed:
            return 'info';
        case StickerState.Packed:
            return 'cyan';
        case StickerState.AddedToRealization:
            return 'emerald';
        case StickerState.Shipped:
            return 'lime';
        // 'Unknown sticker status';
        case StickerState.PlacedOnStock:
        case StickerState.ReturnFromCustomer:
        case StickerState.CanceledByCustomer:
        case StickerState.ReceivedAtDeliveryPoint:
        case StickerState.HandedToCustomer:
        case StickerState.SentToPartnerDeliveryService:
            return 'pink';
        case StickerState.Unknown:
            return 'default';
        default: {
            stickerState;
            return 'default';
            // throw new Error(`Unhandled StickerState case: ${exhaustiveCheck}`);
        }
    }
}
